import React, {useState} from "react";
import {
  Button,
  Card,
  CardText,
  CardTitle,
  Grid,
  TableColumn,
  SelectField,
  Cell,
  TextField,
} from "react-md";
import { CSVLink } from "react-csv";
import "../../css/mediaCss.css";
import Toggle from "react-toggle";
import { colorsArray, getColorsArrayDisPlayOrder, AngleDisplayOptions } from "./commonHelpers";

const VariablesTable = (props) => {
  const { classNameString, data } = props;
  if (!data) return null;

  return (
    <Card className={classNameString} style={{ marginLeft: "0px" }}>
      <CardTitle
        title="Vectors Configuration"
        subtitle="Edit variables used in the Question"
        className="variable-table-card-title"
      />
      <CardText>
        {Array.from(data.values()).map((variableObj, i) => {
          const isCompValid = variableObj.inputType === "components" && (variableObj.variableType === "RANGE" || variableObj.variableType === "LIST" );
          const isAnglevalid = variableObj.inputType === "angle-magnitude" && (variableObj.variableType === "INT" || variableObj.variableType === "FLOAT" );
        
          return (
            <Grid key={i}>
              { i !== 0 && <div className="section-break-line"></div>}
              <Cell size={3}>
                <TextField
                  className="textFieldClass heightLight"
                  disabled
                  value={variableObj.name}
                  label={"Vector-"+ (i+1)}
                  id={`text-field-${i}`}
                />
              </Cell>
              <Cell size={3}>
                {/* <TextField
                        className="textFieldClass"
                        value={variableObj.color}
                        label="Color"
                        id={`text-color-${i}`}
                        type="color"
                        onChange={(value) => {
                          variableObj.color = value;
                          props.onTableRowChange(variableObj);
                        }}
                        helpText="color hex values : #F79722, #0AAAFA, #FF5500, #09B83E, #34465D, #E4405F"
                      /> */}
                <SelectField
                  helpText="color hex values : #F79722, #0AAAFA, #FF5500, #09B83E, #34465D, #E4405F"
                  id={`text-color-${i}`}
                  label="Color"
                  fullWidth
                  onChange={(value) => {
                    variableObj.color = value;
                    props.onTableRowChange(variableObj);
                  }}
                  menuItems={colorsArray}
                  value={variableObj.color}
                />
              </Cell>
              <Cell size={3}>
                <SelectField
                  helpText="Select a vector input value type"
                  id={`variable-type-${i}`}
                  label="Type"
                  fullWidth
                  onChange={(value) => {
                    variableObj.inputType = value;
                    if (value === "components") {
                      variableObj.variableType = "RANGE";
                    } else {
                      variableObj.variableType = "INT";
                    }
                    
                    props.onTableRowChange(variableObj);
                  }}
                  menuItems={["components", "angle-magnitude"]}
                  value={variableObj.inputType}
                />
              </Cell>
              <Cell size={3}>
                {variableObj.inputType === "components" ? (
                  <SelectField
                    helpText="Select a vector variable type"
                    id={`variable-type1-${i}`}
                    label="Type"
                    onChange={(value) => {
                      variableObj.variableType = value;
                      props.onTableRowChange(variableObj);
                    }}
                    menuItems={["RANGE", "LIST"]}
                    value={variableObj.variableType}
                  />
                ) : (
                  <SelectField
                    helpText="Select a vector variable type"
                    id={`variable-type1-${i}`}
                    label="Type"
                    onChange={(value) => {
                      variableObj.variableType = value;
                      props.onTableRowChange(variableObj);
                    }}
                    menuItems={["INT", "FLOAT"]}
                    value={variableObj.variableType}
                  />
                )}
              </Cell>
              
              {(isCompValid || isAnglevalid) && <GetRow1 variableObj={variableObj} i={i} props={props} />}
              {(isCompValid || isAnglevalid) && <GetRow2 variableObj={variableObj} i={i} props={props} />}
              
              <Cell size={3}>
                <label
                  htmlFor={`show-label-check-${i}`}
                  className="vectors-toggle-label"
                >
                  {"Show Label"}
                </label>
                <Toggle
                  icons={false}
                  width={230}
                  id={`show-label-check-${i}`}
                  name="Show Label"
                  onChange={(event) => {
                    variableObj.showLabel = event.target.checked;
                    props.onTableRowChange(variableObj);
                  }}
                  checked={variableObj.showLabel}
                />
              </Cell>
              <Cell size={3}>
                <label
                  htmlFor={`show-angle-check-${i}`}
                  className="vectors-toggle-label"
                >
                  {"Show Angle"}
                </label>
                <Toggle
                  icons={false}
                  width={230}
                  id={`show-angle-check-${i}`}
                  name="Show Angle"
                  onChange={(event) => {
                    variableObj.showAngle = event.target.checked;
                    props.onTableRowChange(variableObj);
                  }}
                  checked={variableObj.showAngle}
                  className="rp-fraction-checkbox"
                  label="Show Angle"
                />
              </Cell>
              <Cell size={3}>
                <label
                  htmlFor={`show-components-check-${i}`}
                  className="vectors-toggle-label"
                >
                  {"Show Components"}
                </label>
                <Toggle
                  icons={false}
                  width={230}
                  id={`show-components-check-${i}`}
                  name="Show Components"
                  onChange={(event) => {
                    variableObj.showComponents = event.target.checked;
                    props.onTableRowChange(variableObj);
                  }}
                  checked={variableObj.showComponents}
                  className="rp-fraction-checkbox"
                  label="Show Components"
                />
              </Cell>
              <Cell size={3}>
                <label
                  htmlFor={`auto-origin-check-${i}`}
                  className="vectors-toggle-label"
                >
                  {"Auto Origin"}
                </label>
                <Toggle
                  icons={false}
                  width={230}
                  id={`auto-origin-check-${i}`}
                  name="Auto Origin"
                  onChange={(event) => {
                    variableObj.autoOrigin = event.target.checked;
                    props.onTableRowChange(variableObj);
                  }}
                  checked={variableObj.autoOrigin}
                  className="rp-fraction-checkbox"
                  label="Auto Origin"
                />
              </Cell>
              <br />
              <AngleOptions
                variableObj={variableObj}
                i={i}
                props={props}
                visible={variableObj.showAngle}
              />
            </Grid>
          )
        })}
      </CardText>
    </Card>
  );
};

const ListValuesSection = (props) => {
  let variableObj = props.variableObj;
  let field = props.field;

  const csvData = [
    [
      "In column 1 enter the Question [variable] values",
      "In columns 2 through n enter the n correct answer value(s)",
    ],
    ["Australia", "Melbourne", "Sydney", "Perth"],
    ["India", "New Delhi", "Mumbai", "Chennai"],
    ["USA", "Columbus", "New York", "San Francisco"],
  ];
  return (
    <TableColumn>
      <TextField
        id="list-values"
        placeholder={props.placeholder}
        type="text"
        label={props.fieldName}
        value={variableObj[field] || ""}
        helpText={props.helpText}
        onChange={(value) => {
          variableObj[field] = value;
          props.onTableRowChange(variableObj);
        }}
      />
      {/*<FileInput onChange={ async (e) => {
              const reader = new FileReader()
              reader.onload = async (e) => { 
                const text = (e.target.result)
                console.log(text)
                alert(text)
              };
              reader.readAsText(e.target.files[0])
            }
        } id="answersCSV" label="Upload CSV File" accept="text/csv"></FileInput>
      <CSVLink filename="List_Question_Answer_template.csv" data={csvData}>
        Download Template
      </CSVLink>{" "}
      <input
        id="fileUpload"
        accept=".csv"
        type="file"
        onClick={(e) => {
          e.target.value = "";
        }}
        onChange={async (e) => {
          e.preventDefault();
          const reader = new FileReader();
          reader.onload = async (e) => {
            const entries = e.target.result?.split('"').join("").split("\n");
            let listValueFromFile;
            let listValueMap = new Map();
            for (const entry of entries) {
              if (entry !== "" && entry !== undefined && entry.length !== 0) {
                let answers = "";
                let row = entry.split(",");
                if (entries.indexOf(entry) === 0) {
                  listValueFromFile = row[0];
                } else {
                  listValueFromFile = listValueFromFile + "," + row[0];
                }
                for (const questAns of row) {
                  if (row.indexOf(questAns) !== 0) {
                    if (row.length <= 2) {
                      answers = questAns;
                    } else if (row.length > 2) {
                      if (answers === undefined || answers === "") {
                        answers = questAns;
                      } else {
                        answers = answers + "," + questAns;
                      }
                    }
                  }
                }
                listValueMap.set(row[0], answers);
              }
            }
            variableObj[field] = listValueFromFile;
            props.onTableRowChange(variableObj);
            props.onUploadFile(listValueMap);
          };
          reader.readAsText(e.target.files[0]);
        }}
      />  */}
    </TableColumn>
  );
};

const GetRow1 = ({variableObj, i, props}) => {

  const [errorXorigin,setErrorXorigin] = useState(false);
  const [xoriginHelperText,setXoriginHelperText] = useState('');
  const [errorXmin,setErrorXmin] = useState(false);
  const [xminHelperText,setXminHelperText] = useState('');
  const [errorXmax,setErrorXmax] = useState(false);
  const [xmaxHelperText,setXmaxHelperText] = useState('');
  const [errorMagmin,setErrorMagmin] = useState(false);
  const [magminHelperText,setMagminHelperText] = useState('');
  const [errorMagmax,setErrorMagmax] = useState(false);
  const [magmaxHelperText,setMagmaxHelperText] = useState('');

const getfirstInput = (type) => {
  return type === "components" ? "vectorBlackListX" : "vectorBlackListMagnitude";
}

const onXoriginChange = () => {
  if(variableObj.posX != ""){
  if(Number(variableObj.posX) < 0 || Number(variableObj.gridWidthUnit) <= Number(variableObj.posX)){
    setErrorXorigin(true);
    setXoriginHelperText(`Vector ${variableObj.name} is going outside the grid.`); 
  }else{
    setErrorXorigin(false);
    setXoriginHelperText('');
  }
 }
 onXmaxChange()
 onXminChange()
}

const onMagminChange = () => {
  if(variableObj.inputType === "angle-magnitude") {
    if(variableObj.magMin != ""){
      if(Number(variableObj.magMax) < Number(variableObj.magMin)) {
        setErrorMagmin(true);
        setMagminHelperText(`mag-min cannot be greater than mag-max`)
      }else{
        setErrorMagmin(false);
        setMagminHelperText('');
      } 
    }           
   }
}

const onMagmaxChange = () => {
  if(variableObj.inputType === "angle-magnitude") {
    if(variableObj.magMax != ""){
      if(Number(variableObj.magMax) < Number(variableObj.magMin)) {
        setErrorMagmax(true);
        setMagmaxHelperText(`mag-max cannot be less than mag-min`)
      }else{
        setErrorMagmax(false);
        setMagmaxHelperText('');
      } 
    }           
   }
}

const onXminChange = () => {
  if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
    if(variableObj.xMin != ""){
      if(Number(variableObj.xMax) < Number(variableObj.xMin)) {
        setErrorXmin(true);
        setXminHelperText(`x-min cannot be greater than x-max`)
      }else if(Number(variableObj.xMin) < -Number(variableObj.posX)){
        setErrorXmin(true);
        setXminHelperText(`Vector ${variableObj.name} is going outside the grid`)
      }
      else{
        setErrorXmin(false);
        setXminHelperText('');
      } 
    }           
   }
}

const onXmaxChange = () => {
  if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
    if(variableObj.xMax != ""){
      if(Number(variableObj.xMax) < Number(variableObj.xMin)) {
        setErrorXmax(true);
        setXmaxHelperText(`x-max cannot be less than x-min`)
      }else if(Number(variableObj.xMax) > Number(variableObj.gridWidthUnit - variableObj.posX)){
        setErrorXmax(true);
        setXmaxHelperText(`Vector ${variableObj.name} is going outside the grid`)
      }
      else{
        setErrorXmax(false);
        setXmaxHelperText('');
      } 
    }           
   }
}

  return (
    <React.Fragment>
        <Grid>
          <Cell size={3}>
              <TextField
                className="textFieldClass"
                error={errorXorigin}
                value={variableObj.posX ? variableObj.posX : ""}
                disabled={variableObj.autoOrigin}
                label="origin-x"
                type="number"
                id={`text-x-${i}`}
                onChange={(value) => {
                  variableObj.posX = value;
                  props.onTableRowChange(variableObj);
                  onXoriginChange();
                }}
                helpText={errorXorigin ? xoriginHelperText:"x component of vector "}
              />
            </Cell>
            {
              variableObj.inputType === "components" ? (
                <>
                {variableObj.variableType === "RANGE" ? (
                  <React.Fragment>
                    <Cell size={3}>
                      <TextField
                        className="textFieldClass"
                        error={errorXmin}
                        value={variableObj.xMin}
                        label="x-min"
                        type="number"
                        id={`text-x-${i}`}
                        onChange={(value) => {
                          variableObj.xMin = value;
                          props.onTableRowChange(variableObj);
                          onXminChange();
                        }}
                        helpText={errorXmin ? xminHelperText:"x component of vector "}
                      />
                    </Cell>
                    <Cell size={3}>
                      <TextField
                        className="textFieldClass"
                        error={errorXmax}
                        value={variableObj.xMax}
                        label="x-max"
                        type="number"
                        id={`text-x-${i}`}
                        onChange={(value) => {
                          variableObj.xMax = value;
                          props.onTableRowChange(variableObj);
                          onXmaxChange();
                        }}
                        helpText={errorXmax ? xmaxHelperText:"x component of vector "}
                      />
                    </Cell>
                  </React.Fragment>
                ) : <ListValuesSection 
                      variableObj={variableObj}
                      field="xList"
                      fieldName="List for X"
                      placeholder='Enter list values seperated by comma " , " '
                      helpText="Enter values seperated by comma eg: 1,2.5,3,4,5"
                      onTableRowChange={props.onTableRowChange}
                />}
                </>
              ): (
                <>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error = {errorMagmin}
                    value={variableObj.magMin}
                    label="mag-min"
                    type="number"
                    id={`mag-min-${i}`}
                    onChange={(value) => {
                      variableObj.magMin = value;
                      props.onTableRowChange(variableObj);
                      onMagminChange();
                    }}
                    helpText={errorMagmin ? magminHelperText:"magnitude of vector "}
                  />
                </Cell>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error = {errorMagmax}
                    value={variableObj.magMax}
                    label="mag-max"
                    type="number"
                    id={`mag-max-${i}`}
                    onChange={(value) => {
                      variableObj.magMax = value;
                      props.onTableRowChange(variableObj);
                      onMagmaxChange();
                    }}
                    helpText={errorMagmax ? magmaxHelperText:"magnitude of vector "}
                  />
                </Cell>
                </>
              )
            }
            {(variableObj.variableType === "RANGE") || (variableObj.inputType === "angle-magnitude") ? (
                <React.Fragment>
                  <Cell size={3}>
                    <TextField
                      id="text-black-list-x"
                      label={`Excluded List for ${variableObj.inputType === "components" ? "X" : "magnitide"}`}
                      placeholder="Multiple values must be comma separated"
                      type="text"
                      helpText="Multiple values must be comma separated"
                      onChange={(value) => {
                        variableObj[getfirstInput(variableObj.inputType)] = value;
                        props.onTableRowChange(variableObj);
                      }}
                      value={variableObj[getfirstInput(variableObj.inputType)] || ""}
                    />
                  </Cell>
                </React.Fragment>
              ) : null}

        </Grid>
      </React.Fragment>
  )
};

const GetRow2 = ({variableObj, i, props}) => {
  
  const [errorYorigin,setErrorYorigin] = useState(false);
  const [yoriginHelperText,setYoriginHelperText] = useState('');
  const [errorYmin,setErrorYmin] = useState(false);
  const [yminHelperText,setYminHelperText] = useState('');
  const [errorYmax,setErrorYmax] = useState(false);
  const [ymaxHelperText,setYmaxHelperText] = useState('');
  const [errorAngmin,setErrorAngmin] = useState(false);
  const [angminHelperText,setAngminHelperText] = useState('');
  const [errorAngmax,setErrorAngmax] = useState(false);
  const [angmaxHelperText,setAngmaxHelperText] = useState('');

  const getsecondInput = (type) => {
    return type === "components" ? "vectorBlackListY" : "vectorBlackListAngle";
  } 

  const onYoriginChange = () => {
    if(variableObj.posY != ""){
    if(Number(variableObj.posY) < 0 || Number(variableObj.gridHeightUnit) <= Number(variableObj.posY)){
      setErrorYorigin(true);
      setYoriginHelperText(`Vector ${variableObj.name} is going outside the grid.`); 
    }else{
      setErrorYorigin(false);
      setYoriginHelperText('');
    }
   }
    onYmaxChange()
    onYminChange()
  }

  const onAngminChange = () => {
    if(variableObj.inputType === "angle-magnitude") {
      if(variableObj.angleMin != ""){
        if(Number(variableObj.angleMax) < Number(variableObj.angleMin)) {
          setErrorAngmin(true);
          setAngminHelperText(`angle-min cannot be greater than angle-max`)
        }else{
          setErrorAngmin(false);
          setAngminHelperText('');
        } 
      }           
     }
  }
  
  const onAngmaxChange = () => {
    if(variableObj.inputType === "angle-magnitude") {
      if(variableObj.angleMax != ""){
        if(Number(variableObj.angleMax) < Number(variableObj.angleMin)) {
          setErrorAngmax(true);
          setAngmaxHelperText(`angle-max cannot be less than angle-min`)
        }else{
          setErrorAngmax(false);
          setAngmaxHelperText('');
        } 
      }           
     }
  }

  const onYminChange = () => {
    if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
      if(variableObj.yMin != ""){
        if(Number(variableObj.yMax) < Number(variableObj.yMin)) {
          setErrorYmin(true);
          setYminHelperText(`y-min cannot be greater than y-max`)
        }else if(Number(variableObj.yMin) < -Number(variableObj.posY)){
          setErrorYmin(true);
          setYminHelperText(`Vector ${variableObj.name} is going outside the grid`)
        }
        else{
          setErrorYmin(false);
          setYminHelperText('');
        } 
      }           
     }
  }
  
  const onYmaxChange = () => {
    if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
      if(variableObj.yMax != ""){
        if(Number(variableObj.yMax) < Number(variableObj.yMin)) {
          setErrorYmax(true);
          setYmaxHelperText(`y-max cannot be less than y-min`)
        }else if(Number(variableObj.yMax) > Number(variableObj.gridHeightUnit - variableObj.posY)){
          setErrorYmax(true);
          setYmaxHelperText(`Vector ${variableObj.name} is going outside the grid`)
        }
        else{
          setErrorYmax(false);
          setYmaxHelperText('');
        } 
      }           
     }
  }
 
  return (
    <React.Fragment>
        <Grid>
          
            <Cell size={3}>
              <TextField
                className="textFieldClass"
                error ={errorYorigin}
                disabled={variableObj.autoOrigin}
                value={variableObj.posY ? variableObj.posY : ""}
                label="origin-y"
                type="number"
                id={`text-y-${i}`}
                onChange={(value) => {
                  variableObj.posY = value;
                  props.onTableRowChange(variableObj);
                  onYoriginChange();
                }}
                helpText={errorYorigin ? yoriginHelperText:"y component of vector "}
              />
            </Cell>
            {variableObj.inputType === "components" ? (
              <>
              {variableObj.variableType === "RANGE" ? (
                  <React.Fragment>
                  <Cell size={3}>
                    <TextField
                      className="textFieldClass"
                      error={errorYmin}
                      value={variableObj.yMin}
                      label="y-min"
                      type="number"
                      id={`text-y-${i}`}
                      onChange={(value) => {
                        variableObj.yMin = value;
                        props.onTableRowChange(variableObj);
                        onYminChange();
                      }}
                      helpText={errorYmin ? yminHelperText:"y component of vector "}
                    />
                  </Cell>
                  <Cell size={3}>
                    <TextField
                      className="textFieldClass"
                      error={errorYmax}
                      value={variableObj.yMax}
                      label="y-max"
                      type="number"
                      id={`text-y-${i}`}
                      onChange={(value) => {
                        variableObj.yMax = value;
                        props.onTableRowChange(variableObj);
                        onYmaxChange();
                      }}
                      helpText={errorYmax ? ymaxHelperText:"y component of vector "}
                    />
                  </Cell>
                  </React.Fragment>
                ) : <ListValuesSection 
                        variableObj={variableObj}
                        field="yList"
                        fieldName="List for Y"
                        placeholder='Enter list values seperated by comma " , " '
                        helpText="Enter values seperated by comma eg: 1,2.5,3,4,5"
                        onTableRowChange={props.onTableRowChange}
                  />}
              </>) : (<>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error={errorAngmin}
                    value={variableObj.angleMin}
                    label="angle-min"
                    type="number"
                    id={`angle-min-${i}`}
                    onChange={(value) => {
                      variableObj.angleMin = value;
                      props.onTableRowChange(variableObj);
                      onAngminChange();
                    }}
                    helpText={errorAngmin ? angminHelperText:"angle component of vector"}
                  />
                </Cell>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error={errorAngmax}
                    value={variableObj.angleMax}
                    label="angle-max"
                    type="number"
                    id={`angle-max-${i}`}
                    onChange={(value) => {
                      variableObj.angleMax = value;
                      props.onTableRowChange(variableObj);
                      onAngmaxChange();
                    }}
                    helpText={errorAngmax ? angmaxHelperText:"angle component of vector"}
                  />
                </Cell>
              </>
            )}

          {(variableObj.variableType === "RANGE") || (variableObj.inputType === "angle-magnitude") ? (
                <React.Fragment>
                  <Cell size={3}>
                    <TextField
                      id="text-black-list-y"
                      label={`Excluded List for ${
                        variableObj.inputType === "components" ? "Y" : "angle"
                      }`}
                      placeholder="Multiple values must be comma separated"
                      type="text"
                      helpText="Multiple values must be comma separated"
                      onChange={(value) => {
                        variableObj[getsecondInput(variableObj.inputType)] = value;
                        props.onTableRowChange(variableObj);
                      }}
                      value={variableObj[getsecondInput(variableObj.inputType)] || ""}
                    />
                  </Cell>
                </React.Fragment>
              ) : null}
          </Grid>
      </React.Fragment>
  )
};

const AngleOptions = ({ variableObj, i, props, visible }) => {
  let angleOptions = variableObj ? variableObj.angleOptions : {};
  if (!angleOptions) {
    {
      angleOptions = {};
    }
  }

  const getHelpText = () => {
    return <p className="custom-tooltip-text">{
      AngleDisplayOptions.map((array, index) => {
        return (<p>Option{index + 1}: {array.label}</p>)
      })}
    </p>
  }

  if (visible) {
    return (
      <React.Fragment>
        <Grid>
          <Cell size={4}>
            <SelectField
              helpText="Select a Angle Display Option"
              id={`angle-option-${i}`}
              label="Angle Display Options"
              onChange={(value) => {
                angleOptions = { ...angleOptions, type: value };
                variableObj.angleOptions = angleOptions;
                props.onTableRowChange(variableObj);
              }}
              menuItems={[1, 2, 3]}
              value={angleOptions.type}
            />
            <Button
              className="nocqcStyle"
              icon
              tooltipLabel={getHelpText()}
            >
              help
            </Button>
          </Cell>
          <Cell size={4}>
            <TextField
              id={`angle-offset-${i}`}
              label="angle offset from base angle"
              placeholder="Offset Angle"
              type="number"
              helpText="The base angle is with reference to x axis, change offset value to change it"
              onChange={(value) => {
                angleOptions = {
                  ...angleOptions,
                  angleOffset: value ? parseFloat(value): '',
                };
                variableObj.angleOptions = angleOptions;
                props.onTableRowChange(variableObj);
              }}
              value={angleOptions.angleOffset}
            />
          </Cell>
          <Cell size={4}>
            <label
              htmlFor={`show-angle-clockwise-${i}`}
              className="vectors-toggle-label"
            >
              {"Angle Direction Clockwise"}
            </label>
            <Toggle
              icons={false}
              width={230}
              id={`show-angle-clockwise-${i}`}
              name="Angle Direction"
              onChange={(event) => {
                angleOptions = {
                  ...angleOptions,
                  clockwise: event.target.checked,
                };
                variableObj.angleOptions = angleOptions;
                props.onTableRowChange(variableObj);
              }}
              checked={angleOptions.clockwise}
            />
          </Cell>
        </Grid>
      </React.Fragment>
    );
  } else {
    return null;
  }
};

export default VariablesTable;

export const createEmptyVectorAnswerFormula = (index) => {
  return {
    name: "",
    formulaType: "components",
    angleFormula: "",
    formulaColor: "#000000", //getColorsArrayDisPlayOrder(index),
    magFormula: "",
    xFormula: "",
    yFormula: "",
    posX: "0",
    posY: "0",
    showComponents: false,
    xOrigin: "5",
    yOrigin: "5",
    autoOrigin: true,
  };
};

export const VectorQuestionHelp = function (props) {
  return [
    <div className="image-resize-warning RTWrapper" key="help-text-1">
      <p>
        <b>Help :</b> Enter vector variable names inside square bracket '[]'. To
        use latex mode, you must use $[ ]$ eg: What is $[\vec&#123;A&#125;]$ $+$
        $[\vec&#123;B&#125;]$?
      </p>
    </div>,
    <br key="help-text-br"></br>,
  ];
};
